import React from 'react'
import {
    BlockWrapper,
    defineBlock,
    smartProps,
    useInspectorControl,
} from '@smartfire/js-block-engine'
import style from './block.module.scss'
import { NavItem } from './NavItem'

const InspectorLazy = React.lazy(() => import('./Inspector'))

export interface ItemProps {
    label: string
    url: string
}

type navigationProps = {
    nav: ItemProps[]
    subNav?: ItemProps[]
    parentSlug?: string | null
}

export const Navigation: React.FC<navigationProps> = ({ nav = [], subNav, parentSlug }) => {
    useInspectorControl(InspectorLazy, [])

    return (
        <BlockWrapper.Div className={style.block}>
            <div className={style.main}>
                <nav className={style.container}>
                    <ul>
                        {nav.map((el) => (
                            <NavItem
                                key={`${el.url}${el.label}`}
                                url={el.url}
                                label={el.label}
                                parentSlug={parentSlug}
                                sameLevelItems={nav}
                            />
                        ))}
                    </ul>
                </nav>
            </div>
            {subNav && (
                <div className={style.sub}>
                    <nav className={style.container}>
                        <ul>
                            {subNav.map((sub) => (
                                <NavItem
                                    key={`${sub.url}${sub.label}`}
                                    url={sub.url}
                                    label={sub.label}
                                />
                            ))}
                        </ul>
                    </nav>
                </div>
            )}
        </BlockWrapper.Div>
    )
}

export default defineBlock({
    Block: Navigation,
    smartProps: {
        nav: smartProps.array.withDefault([
            {
                label: '',
                url: '',
            },
        ]),
    },
    setup: {
        title: 'Navigation',
    },
})
